<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12">
    <g fill-rule="evenodd">
      <path d="M8.134 5.5a1 1 0 1 0 1.732-1 1 1 0 0 0-1.732 1Z" fill-rule="nonzero" fill="currentColor" />
      <path
        fill="currentColor"
        d="M13.938 3.243c.257-.926-.312-1.877-1.27-2.125L8.576.059a1.853 1.853 0 0 0-1.363.173L.899 3.752c-.86.48-1.154 1.541-.658 2.37l2.995 5.01c.496.83 1.595 1.114 2.455.635l6.314-3.52c.413-.23.714-.609.837-1.054l1.096-3.95Zm-1.58-1.008c.32.083.509.4.423.708l-1.096 3.951a.581.581 0 0 1-.28.351l-6.313 3.52a.61.61 0 0 1-.818-.211l-2.995-5.01a.568.568 0 0 1 .219-.79l6.314-3.52a.618.618 0 0 1 .454-.057l4.092 1.058Z"
      />
    </g>
  </svg>
</template>
